import { UserRef } from './user'
import { ListingRef } from './listing'
import { Charger } from './charger'
import { ConnectorV2 } from './connector'
import { TenantRef } from './tenant'
import { CarRef } from './car'
import { Currency } from './plan'

// V3 Transaction types
export type V3TransactionStartMethod = 'mobile' | 'web' | 'rfid' | 'plug_and_charge' | 'plug_and_play' | 'pos' | 'sms' | 'partner' | 'ocpi'
export type V3TransactionState = 'initiating' | 'failed_initiation' | 'verified' | 'failed_charging' | 'starting' | 'in_progress' | 'pending_unplug' | 'completed' | 'hardware_error'

export interface V3Transaction {
  id: number
  ocppTransactionId?: number
  percent: number
  percentStart: number | null
  startMethod: string
  currentState: V3TransactionState
  currentChargingDuration: number
  /** Shown on hover over transaction state when present (API may send error_code_message or errorCodeMessage) */
  error_code_message?: string
  errorCodeMessage?: string

  startAt: string
  endAt?: string
  chargeStartAt?: string
  chargeEndAt?: string
  /** Loitering start time (timestamp); used for time_based loitering. */
  loiteringStartTime?: string
  hasLoitering?: boolean
  loiteringDuration?: number
  /** Loitering display: no_penalty = hide; status_based = suspendedDurations; time_based = loiteringStartTime to endAt */
  loiteringStatus?: 'no_penalty' | 'status_based' | 'time_based'
  /** status_based: intervals to sum for loitering duration */
  suspendedDurations?: Array<{
    startTime?: string
    endTime?: string
  }>

  timezone: string
  duration: number
  energy: number
  financial: Financial
  charger: Charger
  tenant: TenantRef
  connector: ConnectorV2
  user: UserRef
  listing: ListingRef
  car?: CarRef
  rfidNumber?: string
  rfidNickName?: string
  payterInfo?: PayterInfo
  payment?: Payment | null
  refund?: Refund | null
  tieredPercent?: number | string
  curtailmentAdjustmentCents?: number | string
  isReservation?: boolean | string
}

export interface Payment {
  state: string
  paymentGateway: string
  /** Shown on hover over payment state when present (API may send payment_error_msg or paymentErrorMsg) */
  payment_error_msg?: string
  paymentErrorMsg?: string
}

export interface Refund {
  state: 'succeeded' | 'failed'
  refundTotalCents: number
  refundSubtotalCents?: number
  refundTaxCents?: number
  reason?: string
  paymentGateway?: string
  paymentErrorMsg?: string
}

export interface PayterInfo {
  serialNumber: string
  terminalTxnId: string
  sessionState: string
  paymentMethod: string
}

export interface TaxDetail {
  taxAmount: number
  taxDisplayName: string
  taxDisplayNote: string
}

export interface Financial {
  subtotal: number
  total: number
  tax: number
  localTax?: number
  serviceFee: number
  tenantAmount: number
  propertySubtotal: number
  propertyTax: number
  currency: Currency
  loiteringFeeCents: number
  loiteringDuration: number | null
  chargingFeeCents: number
  flatFeeCents: number
  guestFeeCents: number
  taxDetails?: TaxDetail[]
}

export const hasEnded = (trx: V3Transaction): boolean => {
  return (
    trx.currentState === 'completed' ||
    trx.currentState === 'failed_initiation' ||
    trx.currentState === 'failed_charging' ||
    trx.currentState === 'hardware_error'
  )
}

export const errorTransaction = (trx: V3Transaction): boolean => {
  // This function seems to check if transaction can be errored
  // Should return true for states that are NOT already in an error state
  return !hasErrored(trx)
}

export const hasErrored = (trx: V3Transaction): boolean => {
  return (
    trx.currentState === 'failed_initiation' ||
    trx.currentState === 'failed_charging' ||
    trx.currentState === 'hardware_error'
  )
}

export const isReservationTransaction = (trx: V3Transaction): boolean => {
  return trx.isReservation === true || trx.isReservation === 'true'
}

